import styles from '../../index.module.scss';
import type { SmartImportChat } from '../useSmartImportChat';

export default function ResultCard({ chat }: { chat: SmartImportChat }) {
	const { result } = chat;
	if (!result) return null;

	if (result.success) {
		return <div className={styles['action-card']}>✓ {result.text}</div>;
	}

	if (result.errors.length === 0) {
		return (
			<div className={styles['action-card']}>
				<div className={styles['action-card__summary']}>{result.text}</div>
				<div className={styles['action-card__buttons']}>
					<button type="button" className={styles['action-card__confirm']} onClick={chat.retryConfirm}>
						Retry
					</button>
				</div>
			</div>
		);
	}

	// 422 pre-validation errors with "Fix in mapping/employees" links.
	return (
		<div className={styles['action-card']}>
			<div className={styles['action-card__summary']}>{result.text}</div>
			<ul className={styles['smart-import-card__error-list']}>
				{result.errors.map((e, i) => {
					const locus = chat.getErrorLocus(e);
					const step = chat.getErrorStep(e);
					return (
						<li key={i}>
							{locus && <strong>{locus}: </strong>}
							{e.message}
							{step === 1 && (
								<button type="button" className={styles['smart-import-card__link-btn']} onClick={() => chat.fixStep(1)}>
									Fix mapping
								</button>
							)}
							{step === 2 && (
								<button type="button" className={styles['smart-import-card__link-btn']} onClick={() => chat.fixStep(2)}>
									Fix employee mapping
								</button>
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
}
